import { UUID } from './types';
import { Attribute } from '@/api/AttributeApi';
import { AttributeValue } from '@/api/AttributeValueApi';
import { Fabric } from '@/api/FabricApi';
import ProductTypeApi, { ProductType } from '@/api/ProductTypeApi';

export type CreatorInitialData = Awaited<
	ReturnType<(typeof ProductTypeApi)['getCreatorInitialData']>
>;

export type AvailableAttributes = CreatorAttribute[];

export type CreatorAttribute = Attribute & {
	attributeValues: AttributeValue[];
	filteredValues: AttributeValue[];
};

export enum CreatorStep {
	CONFIGURATION,
	ACCESSORIES,
	SUMMARY,
}

export interface CreatorOptions {
	currentStep: CreatorStep;
}

export interface CreatorDimensions {
	width?: number;
	height?: number;
}

export interface CreatorProduct {
	id: UUID | null;
	widthInputMode: string;
	heightInputMode: string;
	quantity: number;
	dimensions: CreatorDimensions;
	comment: string;
	price: number;
	discountedPrice: number;
}

export interface CreatorAccessory {
	id?: UUID;
	quantity: number;
	accessoryId: UUID;
}

export interface CreatorState {
	productType: ProductType | null;
	selectedCategoryId: UUID | null;
	selectedFabric: Fabric | null;
	creatorProduct: CreatorProduct;
	selectedValues: Record<UUID, AttributeValue | null>;
	creatorAccessories: CreatorAccessory[];
	availableAttributes: AvailableAttributes;
	options: CreatorOptions;
}

export interface SerializedCreator {}
